/* import __COLOCATED_TEMPLATE__ from './lead-sources.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();